//****************************************************************************//
//                         DELIVERY OPTION SERVICE                           //
//****************************************************************************//

/*

ALL THE NETWORK CALLS MADE TO UPDATE OR RETRIEVE DELIVERY INFORMATION SHOULD GO HERE

*/

import { NETWORK_URLS } from '../constants/NetworkConstants';
import { apiUrl, headerHelper } from '../helper/Utility'

export default class DeliveryOptionsService {
  static getDeliveryOptions = async () => {
    var headers = new Headers();
    headers.append('Content-Type', 'application/json');
    headers.append('Authorization', 'Token token=SJ46Qx10BuKXH360zJ4Tc2rh5ZlK3EXQ');

    try {
      const response = await fetch(
        `${NETWORK_URLS.api_url}${NETWORK_URLS.get_delivery_options}`, {
        method: 'GET',
        headers: headers,
      }
      );
      const json = await response.json();
      return json;
    }

    catch {
      console.log("error");
      return [];
    }
  }

  static getPickupOptions = async (token,store_id) => {
    var endpoint = NETWORK_URLS.store_pickup_option.replace('store_id',store_id);
    var encodedUrl = apiUrl() + endpoint;
    try {
      var response = await fetch(encodedUrl,{method: 'GET', headers: headerHelper(token)});
      var responseJson = await response.json();
      return [responseJson];
    } catch (e) {
      console.log(e);
      return [];
    }
  }
}